<template>
  <div>
    <Modal title="SQL" width="800" v-model="tModal">
      <div class="ace-editor" :id="id"></div>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="ok">确认</Button>
        <Button @click="tModal = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import '@/view/database/ace-export'
export default {
  name: 'writeSqlModal',
  data () {
    return {
      themePath: 'ace/theme/sqlserver',
      modePath: 'ace/mode/sql',
      aceEditor: '',
      tModal: false,
      type: '',
      id: 'ace-editor' + this.iRandom()
    }
  },
  mounted: function () {
    this.aceEditor = ace.edit(this.id, {
      maxLines: 30,
      minLines: 20,
      fontSize: 14,
      value: '',
      theme: this.themePath,
      mode: this.modePath,
      wrap: 1,
      tabSize: 4
    })
    // 激活自动提示
    this.aceEditor.setOptions({
      enableSnippets: true,
      enableLiveAutocompletion: true,
      enableBasicAutocompletion: true,
      printMargin: false,
      printMarginColumn: 120
    })
  },
  methods: {
    // 随机生成数
    iRandom () {
      return (new Date()).getTime() + Math.round(Math.random() * 100000) + ''
    },
    open (initSQL = '', type = '') {
      this.type = type
      if (this.aceEditor) {
        this.aceEditor.setValue(initSQL)
      }
      this.tModal = true
    },
    ok () {
      let value = this.aceEditor.getValue()
      this.$emit('complete', value, this.type)
      this.tModal = false
    }
  }
}
</script>

<style scoped>

</style>
